import { Button } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { useToggle } from 'hooks';
import { IItemKey } from 'api/catalog/models';

import messages from './messages';
import VisibilityOptionsDialog from './VisibilityOptionsDialog';

export interface IVisibilityOptionsDialogProps {
  disabledOptions?: IItemKey[];
  defaultOptions?: IItemKey[];
  selectedOptions?: IItemKey[];
  onSelectedOptionsChange?: (selected: IItemKey[]) => void;
}

const VisibilityOptions = (props: IVisibilityOptionsDialogProps) => {
  const { val: isDialogOpen, toggle: toggleIsDialogOpen } = useToggle();

  return (
    <React.Fragment>
      <Button variant='contained' onClick={toggleIsDialogOpen}>
        <FormattedMessage {...messages.buttonText} />
        <SettingsIcon sx={{ marginLeft: '10px' }} />
      </Button>
      {isDialogOpen ? (
        <VisibilityOptionsDialog
          onToggleDialogOpen={toggleIsDialogOpen}
          {...props}
        />
      ) : null}
    </React.Fragment>
  );
};

export default VisibilityOptions;
